import React, { useState } from 'react';
import SdkHero from "../components/sdk/SdkHero";
import SdkShowcase from "../components/sdk/SdkShowcase";
import LanguageTabs from "../components/sdk/LanguageTabs";
import InstallationGuide from "../components/sdk/InstallationGuide";
import QuickStart from "../components/sdk/QuickStart";
import SdkFeatures from "../components/sdk/SdkFeatures";
import MigrationGuide from "../components/sdk/MigrationGuide";


const SdkPage = () => {
    const [activeLanguage, setActiveLanguage] = useState('javascript');

    return (
        <div className="min-h-screen bg-gray-50 dark:bg-slate-950 dark:text-slate-100 pt-16">
            <SdkHero />
            <SdkShowcase />

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
                <LanguageTabs
                    activeLanguage={activeLanguage}
                    onLanguageChange={setActiveLanguage}
                />

                <div className="grid lg:grid-cols-3 gap-8 mt-8">
                    <div className="lg:col-span-2">
                        <InstallationGuide language={activeLanguage} />
                        <QuickStart language={activeLanguage} />
                    </div>

                    <div className="lg:col-span-1">
                        <SdkFeatures />
                        <MigrationGuide />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SdkPage;